import { ApiGateway } from '@ydegouvello/lib-api-gateway';

export class BackendGateway extends ApiGateway {
  private static _instance: BackendGateway | undefined;

  private constructor(baseUrl: string) {
    super(baseUrl);
  }

  static getInstance(baseUrl = '/api/index.php?action='): BackendGateway {
    this._instance ??= new this(baseUrl);
    return this._instance;
  }
}
